import React from 'react';
// styles
import styled from 'styled-components';

const CalendarIcon = ({ className, ...props }) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Calendar"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5002 2H14.3335C15.0699 2 15.6668 2.59695 15.6668 3.33333V14.6667C15.6668 15.403 15.0699 16 14.3335 16H1.66683C0.93045 16 0.333496 15.403 0.333496 14.6667V3.33333C0.333496 2.59695 0.93045 2 1.66683 2H2.66683C2.85092 2 3.00016 2.14924 3.00016 2.33333V3.83333C3.00016 4.10948 3.22402 4.33333 3.50016 4.33333C3.77631 4.33333 4.00016 4.10948 4.00016 3.83333V0.666667C4.00016 0.298477 4.29864 0 4.66683 0C5.03502 0 5.3335 0.298477 5.3335 0.666667V1.834C5.33386 1.92579 5.40838 2 5.50016 2H9.66683C9.85092 2 10.0002 2.14924 10.0002 2.33333V3.83333C10.0002 4.10948 10.224 4.33333 10.5002 4.33333C10.7763 4.33333 11.0002 4.10948 11.0002 3.83333V0.666667C11.0002 0.298477 11.2986 0 11.6668 0C12.035 0 12.3335 0.298477 12.3335 0.666667V1.83333C12.3335 1.92538 12.4081 2 12.5002 2ZM14.0002 14.6667C14.1843 14.6667 14.3335 14.5174 14.3335 14.3333V6.33333C14.3335 6.14924 14.1843 6 14.0002 6H2.00016C1.81607 6 1.66683 6.14924 1.66683 6.33333V14.3333C1.66683 14.5174 1.81607 14.6667 2.00016 14.6667H14.0002Z"
      fill="#263340"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66699 10.3333C4.66699 8.49238 6.15938 7 8.00033 7C8.88438 7 9.73223 7.35119 10.3573 7.97631C10.9825 8.60143 11.3337 9.44928 11.3337 10.3333C11.3337 12.1743 9.84127 13.6667 8.00033 13.6667C6.15938 13.6667 4.66699 12.1743 4.66699 10.3333ZM8.27226 11.8191L9.88626 9.66639H9.88559C10.0513 9.44548 10.0065 9.13208 9.78559 8.96639C9.56468 8.80071 9.25128 8.84548 9.08559 9.06639L7.52959 11.1397L6.76359 10.3731C6.63812 10.243 6.45224 10.1908 6.27741 10.2365C6.10257 10.2822 5.96598 10.4186 5.92014 10.5934C5.8743 10.7682 5.92634 10.9541 6.05626 11.0797L6.88893 11.9157C7.07677 12.1042 7.3372 12.2019 7.60267 12.1833C7.86814 12.1648 8.11246 12.0319 8.27226 11.8191Z"
      fill="#263340"
    />
  </svg>
);

export default styled(CalendarIcon)``;
